import { Link } from "react-router-dom";
import { ForgotPasswordForm } from "./ForgotPasswordForm";
import { useTranslation } from "react-i18next";

export const ForgotPassword = () => {
  const {t} = useTranslation()
  return (
    <>
      <div className="container">
        <section className="flex flex-col md:flex-row h-screen items-center">
          <div className="hidden md:block bg-white w-full md:max-w-md lg:max-w-full md:mx-0 md:w-1/2 xl:w-2/3 h-screen px-6 lg:px-16 xl:px-12">
            <div className="mt-6 w-full h-100 py-5 flex items-center justify-center">
              <div className="">
                <div className="py-3 text-2xl font-semibold">
                  <h1 className="">
                    {t('forgot_password_title')}
                  </h1>
                </div>
                <div className="py-5">
                  <p>{t('signin_prompt')}</p>
                </div>
                <div className="py-5">
                  <div className="">
                    <div>
                      {t('signup_prompt')}
                      <span className="px-3">
                        <Link
                          to="/auth/register"
                          className="text-sky-600 font-medium	"
                        >
                          {t('signup_prompt_2')}
                        </Link>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-indigo w-full md:max-w-md lg:max-w-full md:mx-0 md:w-1/2 xl:w-1/2 h-screen px-6 lg:px-16 xl:px-12">
            <div className="w-full h-100">
              <ForgotPasswordForm />
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
